// ビルド時に vite.config.js の define で注入される定数
// ★SPEC-SW-PRECACHE-HASH-CHAIN-FIX-V1 (D-606): BUILD_TIME だけはここに置かない。
//   ビルド時刻は毎ビルド変わるので、焼き込むとこのモジュールのハッシュが毎回変わり、
//   import している 159 チャンクへ連鎖する(D-605-DIAG で実測)。
//   下の 3 つはコミットが同じなら同じ値なので連鎖しない=定数のままでよい。
//   時刻は version.json から実行時に読む(useBuildTime)。
/* eslint-disable no-undef */
export const BUILD_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev'
export const BUILD_SHA = typeof __GIT_SHA__ !== 'undefined' ? __GIT_SHA__ : 'local'
export const BUILD_NUMBER = typeof __BUILD_NUMBER__ !== 'undefined' ? __BUILD_NUMBER__ : '0'
/* eslint-enable no-undef */

/**
 * 画面右下の build ラベル。
 * ★buildTime は version.json 由来の実行時の値。まだ来ていない/取れない/壊れている場合は
 *   時刻だけ落として出す。空にしない(build 番号と sha は版の特定にそのまま使える)。
 * @param {string|null|undefined} buildTime ISO 文字列
 */
export function buildLabel(buildTime) {
  const base = `build #${BUILD_NUMBER} · ${BUILD_SHA}`
  if (!buildTime) return base
  const d = new Date(buildTime)
  // ★壊れた値で Invalid Date を出さない。
  if (Number.isNaN(d.getTime())) return base
  const ts = d.toLocaleString('ja-JP', {
    timeZone: 'Asia/Tokyo', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit',
  })
  return `${base} · ${ts}`
}
